import { memo, useEffect } from 'react'
import { useFeature } from '@cbgms/base/feature-flags'
import { useGridV1Context } from '@cbgms/components/grid/Contexts/GridV1Context'
import TopBarV1 from 'app/menu/components/TopBarV1/TopBar'
import TopBarV2, { Props } from 'app/menu/components/TopBarV2/TopBar'

const _TopBarContainer: React.FC<Props> = props => {
  const useV2 = useFeature('b2b-design-v2')
  const { setTopBarHeight } = useGridV1Context()

  useEffect(() => {
    useV2 ? setTopBarHeight(94) : setTopBarHeight(64)
  }, [useV2])

  if (useV2) {
    return <TopBarV2 {...props} />
  }
  return <TopBarV1 {...props} />
}

export const TopBarContainer = memo(_TopBarContainer)
